/**
 * @param {object} initData
 * @desc AddHumany add's the humany widget code to the page's that want to show the FAQ chat widget
 */
const AddHumany = initData => {
    if (initData) {
        (function(n, t, i, r, u, f, e) {
            for (
                var o, s = /[?&]{1}(humany[^=]*)=([^&#]*)/g;
                (o = s.exec(n.location.search));

            ) {
                i += (i.indexOf('?') > -1 ? '&' : '?') + o[1] + '=' + o[2];
            }
            f = t.createElement(u);
            f.async = !0;
            f.src = i;
            e = t.getElementsByTagName(u)[0];
            e.parentNode.insertBefore(f, e);
            n[r] = n[r] || {
                _c: [],
                configure: function(t) {
                    n[r]._c.push(t);
                }
            };
        })(
            window,
            document,
            '//tradera.humany.net/default/embed.js',
            'Humany',
            'script'
        );
    }
};

export default AddHumany;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/humany/humany.js